import { MdrCompaniesGridController } from '../controller/MdrCompaniesGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MdrCompaniesGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MdrCompaniesGridController,
    });
  }
}
